export default __webpack_public_path__ + "static/media/hardware-trial-kit.04c9f319.png";